/**
 * BoxContainer registration: the parser. It parses `alignment` and `vertical`
 * for the native (WebGL canvas) container layout in `nativeSolver.ts`.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseBoxContainer } from './parser';
const boxContainerRegistration = {
    typeName: 'BoxContainer',
    parser: parseBoxContainer,
};
nodeRegistry.register(boxContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map